/* eslint-disable no-undef */
(function (window) {
    "use strict";
    function defineReportService() {
        let reportService = {};
        reportService.getReportYearsAndMonths = function () {
            return axios.get("/api/ReportService/GetReportYearsAndMonths");
        };
        reportService.getDeliveryOrderSummary = function (startDate, endDate) {
            return axios.get("/api/ReportService/GetDeliveryOrderSummary?StartDate=" + startDate + "&EndDate=" + endDate);
        };
        reportService.getCollectionOrderSummary = function (startDate, endDate) {
            return axios.get("/api/ReportService/GetCollectionOrderSummary?StartDate=" + startDate + "&EndDate=" + endDate);
        };
        return reportService;
    }
    //define globally if it doesn't already exist
    if (typeof (reportService) === "undefined") {
        window.reportService = defineReportService();
    } else {
        console.log("reportService already defined.");
    }
})(window);